var map = {
	"./de-DE.json": 192,
	"./en-AU.json": 193,
	"./en-GB.json": 194,
	"./en-IE.json": 195,
	"./en-US.json": 196,
	"./es-ES.json": 197,
	"./es-MX.json": 198,
	"./fr-CA.json": 199,
	"./fr-FR.json": 200,
	"./it-IT.json": 201,
	"./pt-BR.json": 202
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 191;